import { Store } from 'src/store/index';

const getEncPublicDesignId = (store: Store) => store.design.encPublicId;
export default getEncPublicDesignId;
